export const EventsMap = {
  BUILD_TEST_LIST_SEARCH: 'ML: search build sessions - build view',
  BUILD_VIEW_ADD_FILTER: 'ML Build View Add Filter',
  BUILD_VIEW_CLEAR_ALL_FILTER: 'ML Build View Filter Clear All',
  BUILD_VIEW_CLICK_ANALYTICS: 'ML: click analytics - header',
  BUILD_VIEW_CLOSE_FILTER: 'ML Build View Filter Close',
  BUILD_VIEW_APPLY_FILTER: 'ML: apply build filter - build view',
  BUILD_VIEW_EDIT_TEST_NAME: 'ML: edited build session name - build view',
  BUILD_VIEW_DELETE_BUILD: 'ML: deleted a build - build view',
  BUILD_VIEW_DOWNLOAD_REPORT: 'ML Build View Download Report',
  BUILD_VIEW_EDIT_BUILD_NAME: 'ML: edited a build name - build view',
  BUILD_VIEW_SEARCH: 'ML: search builds - build view',
  BUILD_VIEW_SELECTED_BUILD: 'ML: select a build - build view',
  BUILD_VIEW_SHARE_WITH_PUBLIC: 'ML Build View Share with Public',
  BUILD_VIEW_CLICK_SHARE_BUILD: 'ML: select share build - build view',
  BUILD_VIEW_SHARE_GENERATE_LINK:
    'ML: generate shareable build link - build view',
  BUILD_VIEW_STOP: 'ML Build View Stop',
  BUILD_VIEW_VISITS: 'ML Build View Visits',
  BUILD_VIEW_CHANGE_SESSION_TAB: 'ML: change session status tab - build view',
  LIVE_INTERACTION_CLICKS: 'ML Live Interaction Clicks',
  LIVE_INTERACTION_REFRESH_LOGS: 'ML Live Interaction Refresh logs clicks',
  LIVE_INTERACTION_ABORT: 'ML Live Interaction Abort test cases button clicks',
  LIVE_INTERACTION_MARK_BUG: 'ML Live Interaction Mark as Bug clicks',
  LIVE_INTERACTION_EXPAND_LOGS: 'ML Live Interaction Expand log view clicks',
  LIVE_INTERACTION_EXPAND_SCREENSHOT:
    'ML Live Interaction Expand Screenshot clicks',
  GLOBAL_SEARCH_CLICKS: 'ML: search tests - build view',
  SWITCH_UI: 'ML Switch UI',
  TEST_DETAILS_BROWSE_TESTS: 'ML: browse tests - test view',
  TEST_DETAILS_COMMAND_LOGS_REPORT_ISSUE:
    'ML: report an issue - command logs - test view',
  TEST_DETAILS_RERUN_TEST_CLICK: 'ML: rerun test cta clicked - test view',
  TEST_DETAILS_RERUN_TEST: 'ML: rerun test - test view',
  TEST_DETAILS_RERUN_HISTORY_CLICK: 'ML: test history cta clicked - test view',
  TEST_DETAILS_MARK_STATUS_CLICK: 'ML: mark status cta clicked - test view',
  TEST_DETAILS_EDIT_TEST_DATA: 'ML: edit test data - test view',
  TEST_DETAILS_CREATE_AN_ISSUE: 'ML: create an issue - test view',
  TEST_DETAILS_COPY_ICON: 'ML: copy test name - test view',
  TEST_DETAILS_NO_CAPABILITY_HELP_LINK: 'ML: click additional support info',
  TEST_DETAILS_NO_CAPABILITY_SEE_DOCS: 'ML: see docs - logs - test view',
  TEST_DETAILS_VIEW_METADATA: 'ML: view metadata - test view',
  TEST_DETAILS_EDIT_TEST_NAME: 'ML: edited test name - test view',
  TEST_DETAILS_DELETE_TEST: 'ML: deleted the test - test view',
  TEST_DETAILS_SHARE_TEST: 'ML: select share test - test view',
  TEST_DETAILS_SHARE_GENERATE_LINK:
    'ML: generate shareable test link - test view',
  TEST_DETAILS_VIEW_ADD_FILTER: 'ML Test View Add Filter',
  TEST_DETAILS_VIEW_BUILD_FILTER_APPLIED: 'ML Test View Build Filter Applied',
  TEST_DETAILS_VIEW_DATE_FILTER_APPLIED: 'ML Test View Date Filter Applied',
  TEST_DETAILS_VIEW_OS_FILTER_APPLIED: 'ML Test View OS Filter Applied',
  TEST_DETAILS_VIEW_SEARCH: 'ML Test View Search ',
  TEST_DETAILS_VIEW_STATUS_FILTER_APPLIED: 'ML Test View Status Filter Applied',
  TEST_DETAILS_VIEW_USER_FILTER_APPLIED: 'ML Test View User Filter Applied',
  TEST_DETAILS_VIEW_SWITCH_TESTS: 'ML: select a build session - build view',
  TEST_DETAILS_VIEW_TAG_FILTER_APPLIED: 'ML Test View Tags Filter Applied',
  TEST_DETAILS_VIEW_DOWNLOAD_VIDEO: 'ML: download test video - test view',
  TEST_DETAILS_VIEW_TEST_INFO: 'ML: select test info tab - test view',
  TEST_DETAILS_VIEW_SCREENSHOTS: 'ML Test View Screenshots',
  TEST_DETAILS_VIEW_VIDEO_PLAYED: 'ML Test View Video Played',
  TEST_DETAILS_VIEW_BROWSER_FILTER_APPLIED:
    'ML Test View Browser Filter Applied',
  TEST_VIEW_SELECT_LOGS: 'ML: select a logs tab - test view',
  TEST_DETAILS_VIEW_COMMAND_LOG_TAB_CLICKS_RECORD:
    'ML: view command parameters - test view',
  TEST_DETAILS_VIEW_COMMAND_LOG_TAB_SEARCH: 'ML Test View Command Logs Search',
  TEST_DETAILS_VIEW_COMMAND_LOG_FILTER: 'ML Test View Command Logs Filters',
  TEST_DETAILS_VIEW_COMMAND_LOG_MARKS_AS_BUG:
    'ML Test View Command Logs Mark as Bug',
  TEST_DETAILS_VIEW_COMMAND_LOG_DOWNLOAD_SCREENSHOT:
    'ML Test View Command Logs Download Screenshot',
  TEST_DETAILS_VIEW_COMMAND_LOG_VIEW_SCREENSHOT:
    'ML Test View Command Logs View Screenshot',
  TEST_VIEW_DOWNLOAD_LOGS: 'ML: download logs - test view',
  TEST_DETAILS_VIEW_EXCEPTION_LOG_CLICKS: 'ML Test View Exceptions Log Clicks',
  TEST_DETAILS_VIEW_EXCEPTION_TAB: 'ML Test View Exceptions Tab',
  TEST_DETAILS_VIEW_NETWORK_TAB_DOWNLOAD_LOGS:
    'ML Test View Network Tab Download Logs',
  TEST_DETAILS_TEST_ANNOTATION_CLICKED: 'ML Test Annotation Clicked',
  TEST_DETAILS_TEST_ANNOTATION_BUTTON_CLICKED:
    'ML Test Annotation Apply Button Clicked',
  HEADER_ACCESS_KEY: 'ML: copy credentials - header',
  HEADER_HELP_ICON: 'ML: get help - help center',
  FREE_MINS_EXPIRING_UPGRADE: 'APB_FreeMinutesExpiringUpgrade',
  FREE_MINS_EXPIRED_UPGRADE: 'APB_FreeMinutesExpiredUpgrade',
  ONBOARDING_BOOK_A_DEMO: 'ML: book a demo - onboarding',
  ONBOARDING_LAUNCH_DEMO: 'ML: launch demo test - new onboarding',
  ONBOARDING_CONFIGURE_TEST_SUITE: 'ML: configure test suite - onboarding',
  ONBOARDING_LEARN_MORE: 'ML: click learn more - onboarding',
  VIEW_TEST_RESULTS: 'ML Onboarding View Test Results',
  ONBOARDING_SELECT_FRAMEWORK: 'ML: select framework - onboarding',
  ONBOARDING_VIEW_DOC: 'ML: view docs - onboarding',
  ONBOARDING_MIGRATE_FROM: 'ML: migrate from - onboarding',
  ONBOARDING_VIEW_TEST_RESULTS: 'ML: click view test results - onboarding',
  ONBOARDING_TALK_TO_EXPERT: 'ML: talk to automation expert - onboarding',
  ONBOARDING_HELP_LINKS: 'ML: click help link - view test results - onboarding',
  ONBOARDING_MIGRATION_HELP_LINKS:
    'ML: click help link - verify migration - onboarding',
  ONBOARDING_VERIFY_MIGRATION: 'ML: verify migration - onboarding',
  ONBOARDING_VIEW_TEST_RESULT: 'ML: view test results - onboarding',
  ONBOARDING_RAN_FIRST_TEST: 'ML: ran the first test - onboarding',
  ONBOARDING_TRY_AGAIN_VERIFY_MIGRATION:
    'ML: try again - verify migration - onboarding',
  ONBOARDING_TRY_AGAIN_VIEW_TEST_RESULTS:
    'ML: try again - view test results - onboarding',
  ONBOARDING_GO_TO_NEXT_STEPS: 'ML: go to next step - demo builds - onboarding',
  ONBOARDING_DEMO_SELECT_BREADCRUMB:
    'ML: select breadcrumb - demo builds - onboarding',
  ONBOARDING_CONFIGURE_TEST_SUITE_SELECT_BREADCRUMB:
    'ML: select breadcrumb - configure test suite - onboarding',
  ONBOARDING_PAGE_VIEWED: 'ML: page viewed - onboarding',
  BUILDS_PAGE_VIEWED: 'ML: page viewed - build view',
  GLOBAL_SEARCH_CHANGE_SEARCH_TYPE:
    'ML: change test search filter - build view',
  FTD_BUILD_PAGE_FLAKY_TEST_CLICK: 'ML: FTD_flaky_test_clicks',
  FTD_VIEW_TEST_GROUP_CLICk: 'ML: FTD_View_Test_Group_Clicks',
  FTD_FEEDBACK_POSITIVE: 'ML: FTD_Feedback_positive',
  FTD_FEEDBACK_NEGATIVE: 'ML: FTD_Feedback_negative',

  // Primer 2.0
  BUILDS_DELETE: 'Builds Delete',
  BUILD_ACTION_SELECTED: 'Build Action Selected',
  BUILD_DELETE: 'Build Delete',
  BUILD_FILTER_CLICKED: 'Build Filter Clicked',
  BUILD_LINK_CLICKED: 'Build Link Clicked',
  BUILD_SEARCH_PERFORMED: 'Build Search Performed',
  BUILD_FILTER_APPLIED: 'Builds Filter Applied',
  BUILD_SORT_APPLIED: 'Build Sort Applied',
  BUILD_VIEW_PAGE: 'Build List Page Viewed',
  COMMAND_ITEM_EXPANDED: 'Command Item Expanded',
  TEST_ACTION_SELECTED: 'Test Action Selected',
  TEST_DETAILS_LINK_CLICKED: 'Test Details Link Clicked',
  TEST_LINK_CLICKED: 'Test Link Clicked',
  TEST_LIST_PAGE_VIEWED: 'Test List Page Viewed',
  TEST_SEARCH_PERFORMED: 'Test Search Performed',
};
